import React, { Fragment, Suspense, useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import { useParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "./Constants";
const BlogDetailsInner = React.lazy(() =>
  import("../components/BlogDetailsInner")
);
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const BlogDetails = () => {
  const {lang,id} = useParams();
  const [data,setData] =  useState({});
  const [related,setRelated] = useState([]);
  const [loading,setLoading] = useState(false);
  useEffect(()=>{
          axios.get(base_url+`/api/single-post/${id}`,{
            headers:{
              language:lang
            }
          }).then(response=>{
            setLoading(true);
            setData(response.data.data)
            setRelated(response.data.related);
          })
      },[]);
  return (
    <>
      <Fragment>
        {loading?(
          <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          

          {/* Breadcrumb */}
          {data && (
            <>
              <NavbarOne og_title={data.name} og_text={data.meta_text} og_image={base_url+'/'+data.image} />
              <Breadcrumb title={data.name} />
              <BlogDetailsInner 
                data={data} 
                related={related} 
              />
            </>
          )}
          

          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
         </Suspense>
        ):(
          <Preloader />
        )}
        
      </Fragment>
    </>
  );
};

export default BlogDetails;
